import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import BrandNarrative from "./components/BrandNarrative";
import FeatureGrid from "./components/FeatureGrid";
import ArticlesSection from "./components/ArticlesSection";
import SocialProof from "./components/SocialProof";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://itaobuy.quest";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Itaobuy Sheet",
  "url": `${siteUrl}/`,
  "description": "Curated product sourcing spreadsheet system for dropshipping sellers and eCommerce resellers. Find trending products with verified supplier data, profit margin breakdowns, and weekly updates.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Itaobuy Sheet",
  "url": `${siteUrl}/`,
  "description": "Curated product sourcing spreadsheet system for dropshipping sellers and eCommerce resellers.",
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <BrandNarrative />
        <FeatureGrid />
        <ArticlesSection />
        <SocialProof />
        <CTASection />
      </main>
      <Footer />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
    </>
  );
}